import React from 'react';
import { PhysicianAvatar } from '~/libraries/physicians/PhysicianAvatar';
import type { PatientPhysicianModel } from './types';
import { PatientPhysicianAssociationEnum } from '@generated';
import { Badge } from '~/shared/components/Badge';

export function PatientPhysicianCard(props: PatientPhysicianModel) {
	return (
		<PhysicianAvatar {...props.physician}>
			{props.patientPhysicianAssociationId === PatientPhysicianAssociationEnum.Primary ? (
				<Badge intent="success" className="ml-2 mt-1">
					Primary
				</Badge>
			) : (
				<Badge intent="neutral" className="ml-2 mt-1">
					{props.patientPhysicianAssociationLabel}
				</Badge>
			)}
		</PhysicianAvatar>
	);
}
